import { Image } from "@openai/apps-sdk-ui/components/Image";

const EMLAKJET_GREEN = "#16a34a";

/**
 * Horizontal scrollable image thumbnails
 */
export function DetailImageThumbnails({
  images,
  selectedImageIndex,
  setSelectedImageIndex,
  isDark,
  maxVisible = 8,
}) {
  if (images.length <= 1) return null;

  return (
    <div className={`flex gap-1.5 p-3 overflow-x-auto ${isDark ? "bg-zinc-800" : "bg-gray-50"}`}>
      {images.slice(0, maxVisible).map((img, idx) => (
        <button
          key={`thumb-${idx}`}
          type="button"
          className={`h-12 w-16 rounded-md overflow-hidden flex-shrink-0 transition-all ${
            idx === selectedImageIndex
              ? "ring-2 ring-offset-1"
              : "opacity-70 hover:opacity-100"
          }`}
          style={{ ringColor: idx === selectedImageIndex ? EMLAKJET_GREEN : undefined }}
          onClick={() => setSelectedImageIndex(idx)}
        >
          <Image src={img} alt={`Görsel ${idx + 1}`} className="h-full w-full object-cover" />
        </button>
      ))}
      {images.length > maxVisible && (
        <div className={`h-12 w-16 rounded-md flex items-center justify-center flex-shrink-0 ${isDark ? "bg-white/10" : "bg-black/10"}`}>
          <span className={`text-xs font-medium ${isDark ? "text-white/60" : "text-black/60"}`}>
            +{images.length - maxVisible}
          </span>
        </div>
      )}
    </div>
  );
}

export default DetailImageThumbnails;
